import "./lib/posthog"; // Must be first import — sets up PostHog before any code uses it.
import { loadTagManager } from "./lib/analytics-loader";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

loadTagManager();

createRoot(document.getElementById("root")!).render(<App />);
